<template>
    <div class="status" v-if="counters" :class="{open:open}">

        <div class="general-state" title="Device stat(s)">
            <div class="gen-state-title" title="">Device state<span v-if="count > 1">s</span>:</div>

            <div class="outer" :class="camStateClass(highest)">
                <div class="inner"/>
                <div class="walker" v-for="(c,index) in count" :key="`walker-${c}-${index}`"
                     :style="walkerOffset(index)"/>
            </div>

        </div>
        <div class="counters" v-if="open">
            <div class="title">Last update:</div>
            <div class="wrapper">

                <transition-group name="slide" appear>
                    <div class="counter" v-for="c in sorted" :key="`counter-info-${c.id}`" :class="camStateClass(c)">
                        <div class="name" :key="`counter-name-${c.id}`">{{ c.entrance }}:</div>
                        <div class="duration" :key="`counter-duration-${c.id}`">~{{ Math.floor(diffMs(c) / 1000) }}
                            <span style="color:#929293;">seconds ago</span>
                        </div>
                    </div>
                </transition-group>

            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'StoreItemCounters',
  props: ['id', 'open'],
  data() {
    return {
      counters: undefined,
      count: 0,
      intervals: {
        counters: undefined
      },
    };
  },
  mounted() {
    this.fetch();
    this.intervals.counters = setInterval(this.fetch, 5000);
  },
  beforeDestroy() {
    clearInterval(this.intervals.counters);
    this.intervals.counters = undefined;
  },

  computed: {
    sorted() {
      return this.counters.sort((a, b) => this.diffMs(b) - this.diffMs(a));
    },

    highest() {
      return this.sorted[0];
    }
  },

  methods: {
    fetch() {
      // Fetch site camera status
      axios.get(process.env.VUE_APP_API_BASE + `/b/v1/intellicount/devices?site_id=${this.id}&api_key=${this.$store.getters.key}`)
        .then((res) => {
          if (res.data) {
            this.counters = res.data.people_counters;
            if (!this.count) {
              this.count = this.counters.length;
            }
          }
        });
    },

    hoverInfo(c) {
      let diff = this.diffMs(c);
      return `${Math.floor(diff / 1000)} seconds ago`;
    },

    stateHeight(c) {
      let diff = this.diffMs(c);
      let increments = 100 / 600000;
      let res = diff * increments;
      return res > 100 ? 100 : res + '%';
    },

    diffMs(c) {
      return moment.utc().diff(moment.utc(c.last_interaction));
    },

    camStateClass(c) {
      let stateClass = 'healthy';
      let diff = this.diffMs(c);

      // 10 minutes = 600000
      // 5 minutes = 300000
      if (diff >= 300000 && diff < 600000) {
        stateClass = 'warning';
      } else if (diff >= 600000) {
        stateClass = 'error';
      }

      return stateClass;
    },
    walkerOffset(index) {
      if (this.count > 0) {
        let delay = 10000 / this.count * index;
        return {
          animationDelay: delay + 'ms'
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.status {
    justify-self: flex-end;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 100%;
    width: 100%;
    flex: 1;
    flex-flow: column;
    --box-shadow-color: #32bf5c;
    background: #FFF;


    &.open {
        flex: 1 1 100%;
        justify-content: space-between;

        .general-state {
            .gen-state-title {
                text-align: left;
            }

            .outer {
                width: 50%;
                padding-top: 50%;
            }
        }
    }

    .general-state {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        flex-flow: column;
        justify-content: flex-start;
        align-items: center;

        .gen-state-title {
            position: relative;
            width: 100%;
            text-align: center;
            top: 0;
            color: #929293;
        }

        .outer {
            top: .5em;
            width: 60%;
            padding-top: 60%;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            box-shadow: 0 0 16px 0 var(--box-shadow-color);
            transition: all cubic-bezier(.25, .8, .25, 1) .2s;
            position: relative;
            margin-bottom: 1.5em;

            // Healthy
            background: var(--box-shadow-color);

            &.warning {
                --box-shadow-color: #EFB06A;
            }

            &.error {
                --box-shadow-color: #E2574E;
            }

            .inner {
                position: absolute;
                top: 10%;
                width: 80%;
                height: 80%;
                background: #FFF;
                border-radius: 50%;
                box-shadow: 0 0 16px 0 var(--box-shadow-color) inset;
                transition: all cubic-bezier(.25, .8, .25, 1) 1s;
            }

            .walker {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                border-radius: 50%;
                display: flex;
                justify-content: center;

                animation: walk 10s linear infinite forwards;

                &::after {
                    transition: all cubic-bezier(.25, .8, .25, 1) 1s;
                    width: 10%;
                    height: 10%;
                    background: var(--box-shadow-color);
                    display: block;
                    content: '';
                    position: absolute;
                    margin: auto;
                    border-radius: 50%;
                    filter: brightness(1.5) blur(.35rem);
                }
            }
        }
    }

    .counters {
        position: relative;
        width: 100%;

        .title {
            margin-bottom: .25em;
            color: #929293;
        }

        .wrapper {
            overflow-y: auto;

            .counter {
                display: flex;
                justify-content: space-between;

                .name {
                }

                .duration {
                }
            }
        }
    }
}

@keyframes walk {
    0% {
        transform: rotateZ(0);
    }
    100% {
        transform: rotateZ(360deg);
    }
}


@media only screen and (max-width: 1280px) {
    .status {
        width: auto;
        display: flex;
        flex-flow: column;

        &.open {
            .general-state{
                height: auto;
                align-self: flex-start;

                .outer {
                    //top: 0;
                    width: 30%;
                    padding-top: 30%;

                }
            }
        }

        .counters {
            font-size: .9em;
        }
    }
}

@media only screen and (max-width: 1024px) {
    .status {
        &.open {
            .general-state {
                .outer {
                    width: 100px;
                    padding-top: 100px;
                }
            }
        }
    }
}

</style>